const { CLIENT_ID, ISSUER, OKTA_TESTING_DISABLEHTTPSCHECK } = process.env;

export default {
	systemIdle: {
		admin: 1500, // 25min (1500) - Inactive Idle, in seconds
		default: 900 // 15min (900) - Inactive Idle, in seconds
	},
	systemTimeout: {
		admin: 1750, // 29.5min (1750) - Timeout Idle, in seconds
		client: 1500 // 25min (1500) - Timeout Idle, in seconds
	},
	oidc: {
		clientId: `${CLIENT_ID}`,
		issuer: `${ISSUER}`,
		redirectUri: "login/callback",
		postLogoutRedirectUri: "/", // default. this will be overridden by env variables in the logout() method
		scopes: ["openid", "profile", "email", "crm_reader", "phone", "address"],
		pkce: true,
		onSessionExpired: (): void => {
			localStorage.clear();
			location.reload();
		},
		testing: {
			disableHttpsCheck: `${OKTA_TESTING_DISABLEHTTPSCHECK}`
		}
	},
	resourceServer: {
		messagesUrl: "http://localhost:8000/api/messages"
	}
};
